import { immutableEmptyArray } from "../lib"

type Timeout = ReturnType<typeof setTimeout>

const { now } = Date

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function leadingThrottleDebouncePromise<T extends any[]>(
  func: (...args: T) => Promise<void>,
  delay: number
): (...args: T) => Promise<void> {
  let timerId: Timeout | undefined
  let lastCallTime = 0
  let pendingPromise: Promise<void> | null = null
  let queuedArgs: T | null = null

  return async (...args: T): Promise<void> => {
    const outerNowValue = now()
    queuedArgs = args || immutableEmptyArray // Always capture latest args

    // If leading edge (first call) or delay has passed since last execution
    if (!lastCallTime || outerNowValue - lastCallTime >= delay) {
      lastCallTime = outerNowValue
      clearTimeout(timerId)
      const queuedArgs2 = queuedArgs

      if (pendingPromise) await pendingPromise
      pendingPromise = func(...queuedArgs2)
      await pendingPromise
      pendingPromise = null
      queuedArgs = null
    }

    // Schedule next execution if needed
    if (!timerId) {
      timerId = setTimeout(async () => {
        timerId = undefined
        if (queuedArgs) {
          const queuedArgs2 = queuedArgs
          lastCallTime = now()
          if (pendingPromise) await pendingPromise
          pendingPromise = func(...queuedArgs2)
          await pendingPromise
          pendingPromise = null
          queuedArgs = null
        }
      }, delay)
    }
  }
}